import Csm from '@/domain/csm/entity/csm.entity';
import Segment from '@/domain/segment/entity/segment.entity';
import Seller from '@/domain/seller/entity/seller.entity';
import LeadOrigin from '@/domain/lead-origin/entity/lead-origin.entity';
import LeadSource from '@/domain/lead-source/entity/lead-source.entity';

export default class ContractPersist {
  minimumBillingAmount: number;

  csm: Csm;

  segment: Segment;

  seller: Seller;

  leadSource: LeadSource;

  leadOrigin: LeadOrigin;

  constructor(obj: any = {}) {
    this.minimumBillingAmount = obj.minimumBillingAmount || 0;
    this.csm = obj.csm || null;
    this.segment = obj.segment || null;
    this.seller = obj.seller || null;
    this.leadSource = obj.leadSource || null;
    this.leadOrigin = obj.leadOrigin || null;
  }

  public static of(obj: any = {}): ContractPersist {
    return new ContractPersist(obj);
  }
}
